import React from 'react';

import kofrika from '../assets/kofrika.svg';
import navis from '../assets/navis.jpg';
import trueworld from '../assets/trueworld.png';
import corporate from '../assets/corporate.jpg';
import eduafrica from '../assets/eduafrica.png';

const Work = () => {
  const projects = [
    { name: 'Kofrika', link: 'https://kofrika.com/', image: kofrika },
    { name: 'Navis Capital', link: 'https://www.naviscapital.com/', image: navis },
    { name: 'Trueworld Studios', link: 'https://trueworldstudios.com/', image: trueworld },
    { name: 'Corporate Conversations', link: 'https://corporateconversations.asia/', image: corporate },
    { name: 'EduAfrica', link: 'https://eduafrica.org/', image: eduafrica },
  ];

  return (
    <div name='work' className='w-full md:min-h-screen text-gray-300 bg-[#0a192f] py-16'>
      <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full'>
        <div className='pb-8'>
          <p className='text-4xl font-bold inline border-b-4 text-gray-300 border-blue-600'>
            Work
          </p>
          <p className='py-6'> Check out some of my recent work</p>
        </div>

        {/* Container */}
        <div className='grid sm:grid-cols-2 md:grid-cols-3 gap-4'>
          {projects.map((item, index) => (
            <div
              key={index}
              style={{ backgroundImage: `url(${item.image})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}
              className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'
            >
              {/* Hover Effects */}
              <div className='opacity-0 group-hover:opacity-100 flex flex-col items-center justify-center'>
                <span className='text-2xl font-bold text-white tracking-wider text-center px-2'>
                  {item.name}
                </span>
                <div className='pt-8 text-center'>
                  <a href={item.link} target="_blank" rel="noreferrer">
                    <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
                      Visit
                    </button>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Work;